import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
// import { makeStyles } from '@material-ui/core/styles'

import FloatValue from '../../../Common/Input/FloatValue'
import { updateTag } from '../../../../modules/reducerTagsActions'
import { TAG_PROPERTIES } from '../../../../modules/tag'
// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

export const TEGPositionX = ({ id, value, warning }) => {
  // const classes = useStyles()
  const dispatch = useDispatch()

  const updateTagValue = useCallback(
    (value) => {
      dispatch(updateTag(id, TAG_PROPERTIES.POS_X, value))
    },
    [dispatch, id]
  )

  return (
    <FloatValue
      label="Posición X"
      value={value}
      warning={warning}
      onChange={updateTagValue}
    />
  )
}

export const TEGPositionY = ({ id, value, warning }) => {
  // const classes = useStyles()
  const dispatch = useDispatch()

  const updateTagValue = useCallback(
    (value) => {
      dispatch(updateTag(id, TAG_PROPERTIES.POS_Y, value))
    },
    [dispatch, id]
  )

  return (
    <FloatValue
      label="Posición Y"
      value={value}
      warning={warning}
      onChange={updateTagValue}
    />
  )
}
export const TEGPositionZ = ({ id, value, warning }) => {
  // const classes = useStyles()
  const dispatch = useDispatch()

  const updateTagValue = useCallback(
    (value) => {
      dispatch(updateTag(id, TAG_PROPERTIES.POS_Z, value))
    },
    [dispatch, id]
  )

  return (
    <FloatValue
      label="Posición Z"
      value={value}
      warning={warning}
      onChange={updateTagValue}
    />
  )
}
